import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  apply: {
    id: 'components.JobOfferBox.apply',
    defaultMessage: 'WIĘCEJ'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/JobOffersList/JobOfferBox/JobOfferBox.intl.js